import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-field-floating full my-5" }
const _hoisted_2 = ["value"]
const _hoisted_3 = {
  key: 0,
  class: "form-field-floating full my-5"
}

import { reactive, ref, watch } from 'vue';
    import { PERCENTAGE_FORMAT_CONFIG } from '@/utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MarketProduitFormPromotionView',
  props: {
        modelValue: { type: Object, default: null },
        startupFormDatas: { type: Object, required: true },
    },
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

    // @ts-expect-error raison: lib externe mal typée
    const props = __props;
    const emit = __emit;
    const loading = ref(false);
    const formData = reactive({
        type_promotion: null as string | null,
        taux_promotion: 0
    });

    watch(props, () => {
        if (props.modelValue) {
            Object.assign(formData, props.modelValue);
        }
    }, { deep: true });

    watch(formData, () => {
        emit('update:modelValue', formData);
    }, { deep: true });

return (_ctx: any,_cache: any) => {
  const _component_money3 = _resolveComponent("money3")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, " Gestion des promotions ", -1)),
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("select", {
        class: "form-input-select",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.type_promotion) = $event)),
        name: "type_promotion",
        id: "type_promotion"
      }, [
        _cache[2] || (_cache[2] = _createElementVNode("option", { value: null }, "Aucune promotion", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.startupFormDatas.types_promotion, (type_promotion, index) => {
          return (_openBlock(), _createElementBlock("option", {
            value: type_promotion.value,
            key: 'type_promotion_' + index
          }, _toDisplayString(type_promotion.label), 9, _hoisted_2))
        }), 128))
      ], 512), [
        [_vModelSelect, formData.type_promotion]
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("label", { for: "type_promotion" }, [
        _createTextVNode("Type promotion "),
        _createElementVNode("b", { class: "color-danger" }, "*")
      ], -1))
    ]),
    (formData.type_promotion == 'PERCENTAGE')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_money3, _mergeProps({
            class: "form-input",
            modelValue: formData.taux_promotion,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.taux_promotion) = $event)),
            name: "taux_promotion",
            id: "taux_promotion",
            placeholder: ""
          }, _unref(PERCENTAGE_FORMAT_CONFIG)), null, 16, ["modelValue"]),
          _cache[4] || (_cache[4] = _createElementVNode("label", { for: "taux_promotion" }, [
            _createTextVNode("Pourcentage de réduction (%) "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})